

interface ProfileHeaderProps {
  userName: string;
  profilePictureUrl: string;
  currentRole?: string;
  currentCompany?: string;
  headline?: string;
  location?: string;
  education?: any[];
  summaryPreview?: string;
}

export function ProfileHeader({
  userName,
  profilePictureUrl,
  currentRole,
  currentCompany,
  headline,
  location,
  education,
  summaryPreview
}: ProfileHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 mb-6 sm:mb-8">
      {/* Profile Picture */}
      <div className="flex-shrink-0">
        <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full overflow-hidden bg-gray-200">
          {profilePictureUrl ? (
            <img
              src={profilePictureUrl}
              alt={userName}
              width={96}
              height={96}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-300">
              <span className="text-2xl sm:text-3xl text-gray-500 font-bold">
                {userName.charAt(0).toUpperCase()}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Name and Details */}
      <div className="flex-1 min-w-0">
        <h3 
          className="text-2xl sm:text-3xl md:text-4xl mb-2"
          style={{ 
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic',
            color: '#1D1D1D',
            fontWeight: 400
          }}
        >
          {userName}
        </h3>
        {(currentRole || currentCompany) && (
          <p 
            className="text-base sm:text-lg mb-2"
            style={{ 
              fontFamily: 'Inter, sans-serif',
              color: '#1D1D1D',
              fontWeight: 500
            }}
          >
            {currentRole} {currentCompany ? `@${currentCompany}` : ''}
          </p>
        )}
        {headline && (
          <p 
            className="text-sm sm:text-base text-gray-600 mb-2"
            style={{ 
              fontFamily: 'Inter, sans-serif',
              lineHeight: '1.5'
            }}
          >
            {headline}
          </p>
        )}
        {(location || (education && education.length > 0)) && (
          <p 
            className="text-sm text-gray-600"
            style={{ 
              fontFamily: 'Inter, sans-serif'
            }}
          >
            {location}
            {location && education && education.length > 0 && ' • '}
            {education && education.length > 0 && (education[0]?.school || education[0]?.name || '')}
            {summaryPreview && (
              <>
                <br />
                {summaryPreview}
              </>
            )}
          </p>
        )}
      </div>
    </div>
  );
}

